import styled from 'styled-components';

export const ItemContainer = styled.div`
  min-width: 100%;
  margin-left: 0px;
  padding-bottom: 25px;
`;

export const HistoricoContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
`;

export const HistoricoContent = styled.div`
  border-radius: 12px;
  border: 1px solid #DDD;
  background: #E9EAEB;
  width: 100%;
  min-height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HistoricoH4 = styled.span`
  color: #262930;
  padding-left: 15px;
  font-family: Public Sans;
  font-size: 16px;
  max-width: 650px;
`;

export const HistoricoH5 = styled.span`
  padding: 4px 16px;
  color: ${props => props.cor};
  font-family: Public Sans;
  font-size: 16px;
`;

export const HistoricoH6 = styled.span`
  color: ${props => props.cor};
  font-family: Public Sans;
  font-size: 16px;
`;

export const DivStatus = styled.div`
  border: 1px solid ${props => props.cor};
  border-radius: 20px;
  background: #FFF;
  margin-right: 15px;
`;

export const DivTooltip = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 25px;
`;